import { OBTENIR_DATA_HORA_ACTUAL_EN_CURS, 
    OBTENIR_DATA_HORA_ACTUAL_FINALITZAT,
    AVIS_INICIALITZAR } from '../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioDataActualEnCurs = (state = ESTAT_INICIAL, action) => {

    switch(action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case OBTENIR_DATA_HORA_ACTUAL_FINALITZAT:
            return ESTAT_INICIAL;

        case OBTENIR_DATA_HORA_ACTUAL_EN_CURS:
            return true;

        default:
            return state;
    }
};

export default peticioDataActualEnCurs;


// WEBPACK FOOTER //
// ./src/reducers/peticioDataActualEnCurs.js